export enum ActionLogType {
	None = 0,
	Order = 1,
	Payment = 2,
	Fraud = 3,
	Information = 4,
}
